import Check from '../Check';
import Report from '../Report';
import { MessageType } from '../Message';
import { hasDuplicateElementName } from './util';
import type { IAttribute } from '../../../stores/model/metamodel/attribute';
import type { IAttributeOwner } from '../../../stores/model/metamodel/attribute_owner';

/**
 * Check if an attribute owner has duplicate attributes (i.e. two attributes
 * with the same name).
 */
class AttributeDuplicateCheck extends Check<IAttribute> {
  static description = 'Check for duplicate attributes';

  check(): Report {
    this.report = new Report();
    // `IAttribute.owner` is typed loosely (IAnyStateTreeNode) in the metamodel
    // to avoid a recursion cycle; at runtime it is always an attribute owner
    // (object type / method), which carries the `attributes` array.
    const list = (this.element.owner as IAttributeOwner).attributes;
    if (hasDuplicateElementName(list, this.element)) {
      this.report.addMessage(
        MessageType.ERROR,
        'Attributes with the same name found.',
        this,
        this.element
      );
    } else {
      this.report.addMessage(
        MessageType.INFORMATION,
        'No attributes with the same name found.',
        this,
        this.element
      );
    }
    return this.report;
  }
}

export default AttributeDuplicateCheck;
